import { render } from "./MyBenefitTotalSearch.vue?vue&type=template&id=9d6e216e"
import script from "./MyBenefitTotalSearch.vue?vue&type=script&lang=js"
export * from "./MyBenefitTotalSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__